import { Component, OnInit } from '@angular/core';
import { isolateLtr } from '../../common/i18n/i18n-helpers';
import { TenantLmsOverviewDto } from '../../models/lms-library';
import { LmsLibraryService } from '../../services/lms-library.service';

/**
 * Tenant-admin dashboard tiles (LMS L6): active learners, completions, certificates and course storage.
 * Renders nothing when the overview can't be loaded (e.g. the plan has no LMS), so the dashboard is unaffected.
 */
@Component({
  selector: 'app-lms-overview-card',
  templateUrl: './lms-overview-card.component.html',
  styleUrls: ['./lms-overview-card.component.scss'],
})
export class LmsOverviewCardComponent implements OnInit {
  data: TenantLmsOverviewDto | null = null;
  loading = true;

  constructor(private api: LmsLibraryService) {}

  ngOnInit(): void {
    this.api.tenantOverview().subscribe({
      next: (res) => {
        this.loading = false;
        this.data = res.isSuccess ? res.value : null;
      },
      error: () => {
        this.loading = false;
        this.data = null;
      },
    });
  }

  /** A positive storage quota (null = unlimited, 0 = no storage allowance). */
  get hasQuota(): boolean {
    const quota = this.data?.storage.quotaBytes;
    return quota !== null && quota !== undefined && quota > 0;
  }

  get noStorageAllowance(): boolean {
    return this.data?.storage.quotaBytes === 0;
  }

  /** "1.4 GB", bidi-isolated so Arabic does not render it as "GB 1.4". */
  size(bytes?: number | null): string {
    const value = bytes ?? 0;
    if (!value) return isolateLtr('0 MB');
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.min(Math.floor(Math.log(value) / Math.log(1024)), units.length - 1);
    return isolateLtr(`${(value / Math.pow(1024, i)).toFixed(i < 2 ? 0 : 1)} ${units[i]}`);
  }
}
